// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2367":"84e7a7524cd72dca","2691":"2ac702a5cef895f1","2888":"f423a80e47b596a9","9545":"506a9e6e6e4b4e4c"}[chunkId] + ".css";
};